import * as React from 'react';
/**
 *
 * Original name: team
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A527
 *
 */
export const TeamSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M74 55V19H19v82h82V55H74ZM42 95V78h8v17h-8Zm26 0H56V72H36v23H25V25h43v70Zm27 0H74V61h21v34Z", fill: "currentColor" }),
    React.createElement("path", { d: "M60 33H33v6h27v-6Zm0 13H33v6h27v-6Zm0 13H33v6h27v-6Z", fill: "currentColor" })));
